import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const fetchRecordedCalls = createAsyncThunk(
  "recordedCalls/fetchRecordedCalls",
  async (
    { page = 1, filters = [], sortModel = [] },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().recordedCalls;
      const { pageSize } = state;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.RECORDED_CALLS.GET_RECORDED_CALLS}?${params.toString()}`
      );

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getRecordingPlaybackUrl = createAsyncThunk(
  "recordedCalls/getRecordingPlaybackUrl",
  async ({ recordingId, format = "mp3" }, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient.get(
        `${ENDPOINTS.RECORDED_CALLS.GET_RECORDING_PLAYBACK}/${recordingId}?format=${format}`,
        { responseType: "blob" }
      );
      return response.data;
    } catch (error) {
      const apiMessage = error.response?.data?.message;
      const fallback = error.message;
      const message = apiMessage || fallback;

      dispatch(
        showNotification({
          message: `Playback failed: ${message}`,
          type: "error",
        })
      );

      return rejectWithValue(message);
    }
  }
);

export const getRecordingDownloadUrl = createAsyncThunk(
  "recordedCalls/getRecordingDownloadUrl",
  async ({ recordingId, format = "mp3" }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `${ENDPOINTS.RECORDED_CALLS.GET_RECORDING_DOWNLOAD}/${recordingId}/download?format=${format}`
      );
      return response.data.download_url;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const retainRecordedCall = createAsyncThunk(
  "recordedCalls/retainRecordedCall",
  async ({ recordedCallId, reason }, { rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        `${ENDPOINTS.RECORDED_CALLS.RETAIN_RECORDED_CALL}/${recordedCallId}/retain`,
        { reason }
      );
      return { recordedCallId, message: response.data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const releaseRecordedCall = createAsyncThunk(
  "recordedCalls/releaseRecordedCall",
  async ({ recordedCallId, reason }, { rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        `${ENDPOINTS.RECORDED_CALLS.RELEASE_RECORDED_CALL}/${recordedCallId}/release`,
        { reason }
      );
      return { recordedCallId, message: response.data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
